import Vue from 'vue'
import Router from 'vue-router'
import UniverseHome from '@/views/UniverseHome'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', component: UniverseHome },
    { path: '*', redirect: '/' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js